module.exports = __webpack_public_path__ + "img/MICROWAVE_AMENITY.74ad5d76.svg";